import React, { useMemo } from 'react'
import systemColors from '../theme/systemColors'
import '../theme/system-scope.css'

const hexToRgb = (hex) => {
  const c = hex.replace('#','')
  const bigint = parseInt(c, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255
  return `${r}, ${g}, ${b}`
}

export const SystemThemeProvider = ({ systemId, children }) => {
  const colorHex = useMemo(() => {
    const stored = sessionStorage.getItem('currentSystemColor')
    if (stored) return stored
    return systemColors[systemId] || '#0ea5e9'
  }, [systemId])

  const rgb = useMemo(() => hexToRgb(colorHex), [colorHex])

  return (
    <div className="system-scope" style={{
      ['--bs-primary']: colorHex,
      ['--system-color']: colorHex,
      ['--system-color-rgb']: rgb
    }}>
      {children}
    </div>
  )
}

export const useSystemTheme = () => {
  const color = sessionStorage.getItem('currentSystemColor')
  return { primary: color || '#0ea5e9' }
}

